import React from 'react'
import EntryPagesChildClass from '../General/EntryPagesChildClass'
import withUseCssVars from '../hooks/withUseCssVars'

class StylingContainerForIframes extends EntryPagesChildClass {
    constructor(props) {
        super(props)
    }

    render() {
        return (
           <></>
        )
    }
}

export default withUseCssVars(StylingContainerForIframes)